import DrawMenu from 'components/drawer/DrawMenu'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {deepTranslate, NullAsDefault, renderSelf} from 'views/Shared'
import {IoSettingsOutline} from "react-icons/io5";

export const ContextActionTypes = Object.freeze({
  VIEW: 'view',
  EDIT: 'edit',
  COPY: 'copy',
  DELETE: 'delete',
  IMPORT: 'import',
  EXPORT: 'export',
  SETTINGS: 'settings',
  CREATE_EVENT: 'create-event',
  CREATE_CHANNEL: 'create-channel',
  CREATE_ORGANIZATION: 'create-organization',
  ADD_TO_RECOMMENDATION: 'add-to-recommandation',
  REMOVE_FROM_RECOMMENDATION: 'remove-to-recommandation',
})

const CustomContextMenu = ({
  icon,
  items = [],
  onMenuSelect = NullAsDefault,
  withTranslate = (t, item) => deepTranslate(t)(item),
  ...props
}) => {
  const t = useTranslate()

  const memoMenu = useMemo(
      () =>
          Array.from(items || [])
              .map((item) => withTranslate(t, item))
              .map(({label, renderLabel = renderSelf, ...rest}) => ({
                ...rest,
                label: renderLabel(label),
              })),
      [t, items]
  )

  return (
      <DrawMenu
          component={icon}
          menu={{
            items: memoMenu,
            onClick: ({key}) => {
              onMenuSelect(key)
            }
          }}
          {...props}>
      </DrawMenu>
  )
}

const DefaultIcon = ({ onClick }) => (
  <div
    onClick={onClick}
    style={{ width: 22, height: 22, borderRadius: 999 }}
    className="mx-auto flex flex-center text-color-400 hover:text-color-100 cursor-pointer">
    <IoSettingsOutline size={16} />
  </div>
)

const createContextMenu = (
  items,
  onMenuSelect,
  { icon = <DefaultIcon />, withTranslate, ...props } = {}
) => (
  <CustomContextMenu
    icon={icon}
    items={items}
    onMenuSelect={onMenuSelect}
    withTranslate={withTranslate}
    {...props}
  />
)

export const ItemContextMenu = ({
  icon,
  item,
  items,
  withTranslate,
  hidden = false,
  onMenuSelect = NullAsDefault,
  ...props
}) =>
  hidden
    ? null
    : createContextMenu(
        items,
        (key) =>
          onMenuSelect(key, {
            item,
          }),
        { icon, withTranslate, ...props }
      )

export default createContextMenu
